<template>
  <div class="relative">
    <button
      :class="[
        'relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        isOn ? 'bg-primary' : 'bg-gray-200',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
      ]"
      :disabled="disabled"
      @click.prevent="toggleSwitch"
    >
      <span
        :class="[
          'inline-block h-4 w-4 transform rounded-full bg-white transition-transform',
          isOn ? 'translate-x-6' : 'translate-x-1',
        ]"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isOn: boolean;
  disabled?: boolean;
}

interface Emits {
  (e: "toggle-switch"): void;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits<Emits>();

const toggleSwitch = () => {
  if (!props.disabled) {
    emit("toggle-switch");
  }
};
</script>
